<template>
    <div class="form" v-if="loaded">
        <h2 v-html="words.activate_title"></h2>
        <div id="number_and_arrows" v-if="numbers.length > 1" :key="activeItem">
            <div>
                <a v-if="activeItem.id > 0" class="move" @click="changeActiveNumber('prev')" v-html="words.prev_num"></a>
            </div>
            <div id="active_number_input" v-html="activeItem.number"></div>
            <div>
                <a v-if="isNext" class="move" @click="changeActiveNumber('next')" v-html="words.next_num"></a>
            </div>
        </div>
        <form @submit.prevent="activate()">
            <ul>
                <li class="form-item">
                    <input inputmode="numeric" maxlength="20" type="text" id="iccid" v-model="activeItem.iccid" autocomplete="off" required/>
                    <label for="iccid" v-html="words.sim_number"></label>
                </li>
            </ul>
            <div class="btn_wrapper">
                <input type="submit" class="btn" :value="words.activate" />
            </div>
        </form>
    </div>
</template>
<script>
import Select2 from 'vue3-select2-component';

export default {
  components: { Select2 },
  props: {
    step: {
      required: true,
      type: Number,
    },
    allowMobility: {
      required: true,
      type: Boolean,
    },
    otpConfirmed: {
      required: true,
      type: Boolean,
    },
    numbers: {
      required: true,
      type: Array,
    },

    
  },
    data() {
        return {
            phoneNumber:'',
            activeNumber:0,
            selectedOption: 0,
            selectedPickupLocation: {
                id: ''
            },
            settingsPickupLocation: {
			language: {
					
				},
				dir: "rtl",
			ajax: {
				url: window.api_url + 'get_pickup_locations',
				headers:{"Authorization" : localStorage.getItem('user_token')},
				data(params) {
					var query = {
						search: params.term,
						_type: 'query',
						name: params.term
					};	  
					return query;
				},
				processResults(response) {
					let list = response.data.items; 
					var ret = [];
					for (let i in list) ret.push({id: list[i].id, text: list[i].name});
					return {
						results:ret
					};
				},
			
			}
		},
            personalInfo:{},
            userLoged:true,
            loaded:false
        }
    },
    mounted(){
        if(this.numbers && this.numbers.length > 0 && this.numbers[0].id !== this.activeNumber) this.activeNumber = this.numbers[0].id;
        const self = this;
        this.settingsPickupLocation.language = {
            noResults(){ return self.words.no_results;},
            searching() { return self.words.searching; }
        }
        this.loadInfo();
    },
    
    computed: {
      words() {
        return this.$store.state.words
      },
      isNext(){
        if(!this.numbers[(this.activeItem.id + 1)])
            {
                return false;
            }
        return this.numbers[(this.activeItem.id + 1)].id; 
    },
    isPrev(){
       
        if(!this.numbers[(this.activeItem.id - 1)])
            {
                return false;
            }
        return this.numbers[(this.activeItem.id - 1)].id; 
    },
    activeItem(){
        var item = {};
        
        for(let i in this.numbers)
            {
                if(this.numbers[i].id == this.activeNumber)
                    {
                        item = this.numbers[i];
                    }
            }
        return item;  
        }, 
    },
    methods:{
        loadInfo(){
            this.api({ action: 'cart/load_info', data: {} }, (data) => {
            if(data.data.error && data.data.error != "")
              {
                this.activateError(data.data.error);
              }
            else{
                this.personalInfo = data.data;
              }
            });
            this.loaded = true;
            this.$store.commit('setIsLoading', {isLoading: false})  
        },
            focus_input(){
                setTimeout(()=>{
                    document.querySelector('.select2-search__field').focus();
                },100)
            },

        delete_cookie(name) {
                document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;domain=' + window.location.hostname + '; path=/;';
        },
        activate(){
            if(!this.activeItem.iccid || this.activeItem.iccid.length < 6){
                this.activateError(this.words.iccid_short);
                return;
            }
            this.activeItem.sim = 0;
            this.submit();
        },
        submit(){
            if(this.activeItem.purchase_type == 'new' || this.activeItem.is_clear_to_mobile == "1" || this.otpConfirmed){
                this.saveNumberInfo();
            } else{
                this.$emit('sendOtpForMobility' , this.activeItem)
            }
		},
        sendConfirmMail(isDelivery = false){
            this.api({ action: 'send_confirm_mail', data:{ item:{phone_number: this.activeItem.number}, 
            order:{is_delivery: isDelivery, ...this.personalInfo, pickup_location_id: this.selectedPickupLocation.id},
            }});
        },
        saveNumberInfo(){
              let form = {};
              form.number = this.activeItem.number;
              form.id = this.activeItem.item_id;
              form.is_esim = this.activeItem.sim;
              form.iccid = this.activeItem.iccid;
              this.$store.commit('setIsLoading', {isLoading: true});

              if(form.is_esim == 2){
                  this.api({ action: 'activate_done_pickup', data: { ...form, pickup_location_id: this.selectedPickupLocation.id }  }, async (data) => {
                    if(data.data.error && data.data.error != ""){
                        this.$store.commit('setIsLoading', {isLoading: false});
                        this.activateError(data.data.error);
                        
                    } 
                    else{
                        const text = this.words.activate_done_pickup;
                        this.sendConfirmMail();
                        this.delete_cookie('CRM_WID_cart_exp');
                        this.delete_cookie('CRM_basket_id');
                        localStorage.removeItem('user_token');
                        localStorage.removeItem('user_token_date');
                        this.activatePromptExit(text, 'success', this.words.confirm);
                    }
                  });
                  this.activeNumber = false;
                  this.$store.commit('setIsLoading', {isLoading: false})  
              }
              else if(form.is_esim == 1)
              {

                        const text = this.words.sim_ordered_success;
                        this.sendConfirmMail(true);
                        this.delete_cookie('CRM_WID_cart_exp');
                        this.delete_cookie('CRM_basket_id');
                        localStorage.removeItem('user_token');
                        localStorage.removeItem('user_token_date');
                        this.activatePromptExit(text, 'success');
                    

              }
              else{
              if(!form.iccid || form.iccid.length < 6)
                  {
                      this.$store.commit('setIsLoading', {isLoading: false});
                      this.activateError(this.words.iccid_short);
                      this.activeNumber = false;
                      return false;
                  }
  
                  this.api({ action: 'api/prov_create_user', data: form  }, (data) => {
                      if(data.data.error && data.data.error != ""){
                          this.activateError(data.data.error);
                      } else{
                            form.domain_user_id = data.data.data.id;
                            this.api({ action: 'api/prov_create_mobile', data: form  }, (data) => {
                            if(data.data.error && data.data.error != "")
                            {
                                this.$store.commit('setIsLoading', {isLoading: false})  
                                this.activateError(data.data.error);
                            }
                            else{
                                let note = "";
                                for (let i in data.data.data.notes)
                                {
                                    note +=' '+data.data.data.notes[i];
                                }
                                this.$store.commit('setIsLoading', {isLoading: false});

                                if(this.numbers.length <= 1){
                                    this.delete_cookie('CRM_WID_cart_exp');
                                    this.delete_cookie('CRM_basket_id');
                                    localStorage.removeItem('user_token');
                                    localStorage.removeItem('user_token_date');
                                }
                                this.$store.commit('setIsLoading', {isLoading: false})  
                                this.$swal({
                                icon: 'success',
                                text: this.words.number_activation_complete,
                                showCloseButton: false,
                                showCancelButton: false, 
                                allowOutsideClick: false,
                                showConfirmButton: true,
                                confirmButtonText: this.words.confirm,
                                }).then(() => {
                                    document.location = '/';
                                });
                            }
                            
                        });
                      }
                  
                    });
              }

          },
        changeActiveNumber(type){
			if(type == 'next')
				{
					this.activeNumber = this.isNext;
				}
			else{
					this.activeNumber = this.isPrev;
			}
		},
        }
}
</script>